class UserAnalyticsMapper {
  static createChartSerieFromResponse(response, id) {
    return {
      id,
      data: response.map(serieData => ({
        x: serieData.date,
        y: serieData.value
      }))
    };
  }
  static createCurrencySeriesFromResponse(response, id, currency) {
    var _response$find, _response$;
    // The response comes grouped by currency, and ordered so the first
    // has the most "real" data (vs dates with 0 shipments purchased)
    const selectedCurrencyData = currency && ((_response$find = response.find(res => res.currency === currency)) === null || _response$find === void 0 ? void 0 : _response$find.data);
    const filteredData = selectedCurrencyData || ((_response$ = response[0]) === null || _response$ === void 0 ? void 0 : _response$.data) || [];
    return {
      id,
      data: filteredData.map(serieData => ({
        x: serieData.date,
        y: serieData.value
      }))
    };
  }
  static createShipmentsByCarrierFromResponse(response) {
    return {
      ...response,
      data: response.data.map(element => ({
        ...element,
        averageCost: element.average_cost
      }))
    };
  }
}

export { UserAnalyticsMapper };
//# sourceMappingURL=UserAnalyticsMapper.js.map
